export enum EnumNotificationType {
    Message = 1,
    Error = 2,
    Payment = 3
  }